import { useAccount } from "@azure/msal-react";

const useUserName = () => {
  const accountInfo = useAccount();

  return accountInfo?.username ?? "";
};

export default useUserName;
